import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Services", href: "#services" },
    { label: "Courses", href: "#courses" },
    { label: "Community", href: "/community" },
    { label: "Farm 🌱", href: "/farm" },
    { label: "Donate ❤️", href: "/donate" },
    { label: "Tutors", href: "#tutors" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-18 py-4">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <div className="w-9 h-9 flex items-center justify-center rounded-full bg-amber-500">
            <i className="ri-graduation-cap-fill text-white text-lg"></i>
          </div>
          <div>
            <span
              className={`font-bold text-lg leading-tight tracking-tight transition-colors duration-300 ${
                scrolled ? "text-gray-900" : "text-white"
              }`}
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Crown SAT
            </span>
            <span
              className={`block text-xs font-medium tracking-widest uppercase transition-colors duration-300 ${
                scrolled ? "text-amber-600" : "text-amber-300"
              }`}
            >
              &amp; University
            </span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map((link) =>
            link.href.startsWith("/") ? (
              <Link
                key={link.label}
                to={link.href}
                className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  scrolled ? "text-gray-600 hover:text-amber-600" : "text-white/90 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.href}
                className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  scrolled ? "text-gray-600 hover:text-amber-600" : "text-white/90 hover:text-white"
                }`}
              >
                {link.label}
              </a>
            )
          )}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="/auth"
            className={`px-4 py-2 rounded-full border text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
              scrolled ? "border-gray-200 text-gray-700 hover:border-amber-400 hover:text-amber-600" : "border-white/40 text-white hover:border-white"
            }`}
          >
            Sign In
          </a>
          <a
            href="#booking"
            className="px-5 py-2 rounded-full bg-amber-500 text-white text-sm font-semibold hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            Free Consultation
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer ${
            scrolled ? "text-gray-800" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-gray-700 text-sm font-medium hover:text-amber-600 cursor-pointer"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#booking"
            className="mt-2 px-5 py-2 rounded-full bg-amber-500 text-white text-sm font-semibold text-center cursor-pointer whitespace-nowrap"
            onClick={() => setMenuOpen(false)}
          >
            Free Consultation
          </a>
        </div>
      )}
    </header>
  );
}
